<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { getS3SingedUrl } from "../../../../api/services/general.service";
import { newFeedbackObject } from "./feedback-controller";
import ImageCroperModel from "../../../../components/models/image-crop";
import { addTestimonial } from "../../../../api/services/cms.service";

export default {
	props: {
		visible: Boolean,
		closeable: Boolean,
	},
	components: {
		"image-cropper-model": ImageCroperModel,
	},
	data() {
		return {
			name: null,
			designation: null,
			feedback: null,
			feedbackImageURL: null,

			isUploadingProcessing: false,
			isUploadSuccess: false,
			isUploadFailed: false,
			isFormSubmited: false,
			showExtraImageCropModel: false,
			extraImageFileToCrop: null,
			croppedFeedbackImage: null,
		};
	},
	validations: {
		name: { required },
		designation: { required },
		feedback: { required },
	},
	computed: {
		showModal: {
			get() {
				return this.visible;
			},
			set(value) {
				if (!value) {
					this.$emit("close");
				}
			},
		},
	},
	mounted() {},
	methods: {
		async clickCreateFeedbackButton() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.isFormSubmited = true;
				this.isUploadingProcessing = true;

				let newFeedbackObject_Pass = new newFeedbackObject();
				newFeedbackObject_Pass.name = this.name;
				newFeedbackObject_Pass.designation = this.designation;
				newFeedbackObject_Pass.feedback = this.feedback;

				if (this.croppedFeedbackImage) {
					const feedbakImageFile = this.$refs.feedbackImageInput.files[0];
					const croppedFeedbackImage = this.croppedFeedbackImage;
					const finalFeedbackImageToPass = await new Promise(function(resolve) {
						return croppedFeedbackImage.toBlob(resolve, feedbakImageFile.type);
					});
					const fileName = feedbakImageFile.name;
					let getUploadedImageURL = await getS3SingedUrl(fileName);

					let getFileUploadResponse = await axios.put(
						getUploadedImageURL.signedUrl,
						finalFeedbackImageToPass
					);

					if (getFileUploadResponse) {
						let fileBaseUrl =
							"https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/";
						newFeedbackObject_Pass.photoURL = fileBaseUrl + fileName;
					}
				}

				const feedbackcreateSuccess = await addTestimonial(
					newFeedbackObject_Pass
				);

				if (feedbackcreateSuccess) {
					this.isUploadingProcessing = false;
					this.isUploadSuccess = true;
				} else if (!feedbackcreateSuccess) {
					this.isUploadingProcessing = false;
					this.isUploadFailed = true;
				}
			} else {
				console.log("Validation Error"); //eslint-disable-line
			}
		},
		extraImageSelected() {
			const imagePreviewCanvers = this.$refs.feedbackImageCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const extraImageFile = this.$refs.feedbackImageInput.files[0];
			this.openCorpExtraImageModel(extraImageFile);
		},
		openCorpExtraImageModel(extraImageFile) {
			this.extraImageFileToCrop = extraImageFile;
			this.showExtraImageCropModel = true;
		},
		setCroppedImageToPreview(croppedImage) {
			const imagePreview = this.$refs.extraImagePreview;
			const imagePreviewCanvers = this.$refs.feedbackImageCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedFeedbackImage = croppedImage;
			this.showExtraImageCropModel = false;
		},
		clickRemoveExtraImage() {
			this.croppedFeedbackImage = null;
			this.feedbackImageURL = null;
			const imagePreviewCanvers = this.$refs.feedbackImageCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);
		},
		clickCloseButton() {
			this.$emit("reload");
		},
	},
};
</script>

<template>
	<!-- Edit Company Model-->
	<b-modal
		v-model="showModal"
		:title="'Feedback erstellen'"
		centered
		hide-footer
		no-close-on-backdrop
		no-close-on-esc
		scrollable
	>
		<div class="row" v-if="!isFormSubmited">
			<!-- Feedback Image -->
			<div class="col-md-3 mb-4">
				<div class="avatar-md mr-4">
					<span ref="extraImagePreview" class="extra-image-preview-after-crop">
						<canvas
							id="feedbackImageCanvas"
							ref="feedbackImageCanvas"
							height="120"
							width="120"
						></canvas>
						<span
							v-if="!this.croppedFeedbackImage"
							class="avatar-title bg-white"
							style="margin-left: -120px"
						>
							<img
								src="https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/cms/testimonial-default-img.png"
								class="rounded-0"
								alt
								height="120"
							/>
						</span>
					</span>
				</div>
			</div>
			<div class="col-md-9 mb-4">
				<div class="">
					<input
						id="feedbackImageInput"
						ref="feedbackImageInput"
						type="file"
						name="file"
						accept="image/*"
						@change="extraImageSelected()"
						style="width: 0.1px; opacity: 0; z-index: -1"
					/>
					<div>
						<label
							for="feedbackImageInput"
							class="text-info ml-3"
							style="cursor: pointer"
						>
							{{ $t("extras.createExtra.form.uploadNewImage") }}
						</label>
						<label class="ml-2" v-if="this.croppedFeedbackImage">
							&#8226;
						</label>
						<label
							class="text-info ml-2"
							@click="clickRemoveExtraImage()"
							style="cursor: pointer"
							v-if="this.croppedFeedbackImage"
						>
							{{ $t("extras.createExtra.form.removeImage") }}
						</label>
					</div>
					<div class="ml-3 text-mute">
						<small>
							{{ $t("extras.createExtra.form.imageSupportText") }}
							<br />
							<b> Bildgröße 500px * 500px </b>
						</small>
					</div>
				</div>
			</div>

			<!-- Feedback Name -->
			<div class="col-md-12 mt-5">
				<div class="mb-4">
					<label>
						Name
						<span class="text-danger">*</span>
						<span class="ml-2">
							<p
								v-if="name"
								class="badge position-absolute"
								:class="{
									'badge-light': name.length !== 50,
									'badge-danger': name.length === 50,
								}"
							>
								{{ name.length }} / 50
							</p>
						</span>
					</label>
					<b-form-group>
						<b-form-input
							v-model="name"
							:placeholder="
								this.$i18n.t('extras.createExtra.form.titlePlaceholder')
							"
							:maxlength="50"
							:class="{ 'is-invalid': $v.name.$error }"
						></b-form-input>
						<div v-if="$v.name.$error" class="invalid-feedback">
							<span v-if="$v.name.$error && !$v.name.required">{{
								$t("extras.createExtra.form.titleRequiredMsg")
							}}</span>
						</div>
					</b-form-group>
				</div>
			</div>
			<!-- Feedback designation -->
			<div class="col-md-12">
				<div class="mb-4">
					<label>
						{{ $t("extras.createExtra.form.titleLabel") }}
						<span class="text-danger">*</span>
						<span class="ml-2">
							<p
								v-if="designation"
								class="badge position-absolute"
								:class="{
									'badge-light': designation.length !== 50,
									'badge-danger': designation.length === 50,
								}"
							>
								{{ designation.length }} / 50
							</p>
						</span>
					</label>
					<b-form-group>
						<b-form-input
							v-model="designation"
							:placeholder="
								this.$i18n.t('extras.createExtra.form.titlePlaceholder')
							"
							:maxlength="50"
							:class="{ 'is-invalid': $v.designation.$error }"
						></b-form-input>
						<div v-if="$v.designation.$error" class="invalid-feedback">
							<span v-if="$v.designation.$error && !$v.designation.required">{{
								$t("extras.createExtra.form.titleRequiredMsg")
							}}</span>
						</div>
					</b-form-group>
				</div>
			</div>
			<!-- Feedback Descrtiption -->
			<div class="col-md-12">
				<div class="mb-4">
					<label>
						{{ $t("extras.createExtra.form.descriptionLabel") }}
						<span class="text-danger">*</span>
						<span class="ml-2">
							<p
								v-if="feedback"
								class="badge position-absolute"
								:class="{
									'badge-light': feedback.length !== 350,
									'badge-danger': feedback.length === 350,
								}"
							>
								{{ feedback.length }} / 350
							</p>
						</span>
					</label>
					<textarea
						v-model="feedback"
						class="form-control"
						name="textarea"
						rows="4"
						:maxlength="350"
						:placeholder="
							this.$i18n.t('extras.createExtra.form.descriptionPlaceholder')
						"
						:class="{ 'is-invalid': $v.feedback.$error }"
					></textarea>
					<div v-if="$v.feedback.$error" class="invalid-feedback">
						<span v-if="$v.feedback.$error && !$v.feedback.required">{{
							$t("extras.createExtra.form.descriptionRequiredMsg")
						}}</span>
					</div>
				</div>
			</div>
			<!-- Save Button -->
			<div class="col-md-12">
				<div class="">
					<b-button variant="success" @click="clickCreateFeedbackButton()">
						<i class="bx bxs-check-circle mr-1"></i>
						{{ $t("general.buttons.create") }}</b-button
					>
				</div>
			</div>
		</div>
		<div class="row" v-else>
			<!-- Uploading Processing -->
			<div class="col-md-12 text-center" v-if="isUploadingProcessing">
				<b-spinner
					style="width: 5rem; height: 5rem"
					class="m-2"
					variant="warning"
					role="status"
				></b-spinner>
				<h5 class="mt-3">
					{{ $t("extras.createExtra.form.uploadProcessingTitle") }}
				</h5>
				<p class="mt-3">
					{{ $t("extras.createExtra.form.uploadProcessingText") }}
				</p>
			</div>
			<!-- Upload Success -->
			<div class="col-md-12 text-center" v-if="isUploadSuccess">
				<i class="bx bx-check-circle bx-tada text-success display-1"></i>
				<h5 class="mt-3">
					{{ $t("extras.createExtra.form.uploadSuccesTitle") }}
				</h5>
				<p class="mt-3 mb-3">
					{{ $t("extras.createExtra.form.uploadSuccessText") }}
				</p>
				<b-button variant="warning" @click="clickCloseButton()">
					<i class="bx bxs-x-circle mr-1"></i>
					{{ $t("general.buttons.close") }}</b-button
				>
			</div>
			<!-- Upload Failed -->
			<div class="col-md-12 text-center" v-if="isUploadFailed">
				<i class="bx bx-x-circle bx-tada text-danger display-1"></i>
				<div class="mt-3">
					{{ $t("extras.createExtra.form.uploadFailedTitle") }}
				</div>
				<p class="mt-3">
					{{ $t("extras.createExtra.form.uploadFailedText") }}
				</p>
			</div>
		</div>

		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showExtraImageCropModel === true"
			:visible="showExtraImageCropModel"
			@close="showExtraImageCropModel = false"
			:imageFile="extraImageFileToCrop"
			@apply="setCroppedImageToPreview"
		/>
	</b-modal>
</template>

<style scoped>
.extra-image-preview-after-crop {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: none;
	width: 120px;
	height: 120px;
	padding: 0;
	margin: 0;
}
</style>
